import axios from "axios";

export const getProPropose = (headers, params) => {
  return axios.get(
    `${process.env.REACT_APP_BACKEND_API_URL}/auth/get-propose-first`,
    { headers, params }
  );
};

// export const createProPropose = (headers, data) => {
//   return axios.post(`${API_URL}/product-proposes`, data, {
//     headers,
//   });
// };

// export const updateProPropose = (headers, id, data) => {
//   return axios.put(`${API_URL}/product-proposes/${id}`, data, {
//     headers,
//   });
// };

// export const getProProposeId = (headers, id) => {
//   return axios.get(`${API_URL}/product-proposes/${id}`, {
//     headers,
//   });
// };
